import type { IntakeStatuses } from '@/hooks/useIntakeForm';

export const isSignedLoe = (status: IntakeStatuses['loeStatus']): boolean =>
  status === 'Signed' || status === 'Signed (Manual)';

export const isSentLoe = (status: IntakeStatuses['loeStatus']): boolean =>
  status === 'Sent' || status === 'Sent (Manual)';
